import React from 'react'
import styled from 'styled-components'
import { SheetField } from '../../../common/types/api/excel'
import { OptionType } from '../../../common/types/utilities'
import SettingsColumn from './SettingsColumn'
interface Props {
    queryFields: string[]
    fields: SheetField[]
    update: (fields: SheetField[]) => void
}

export default function SettingsColumns({ queryFields, fields, update }: Props): JSX.Element {

    const options = queryFields?.map(_field => {
        return { label: _field, value: _field } as OptionType
    }) as OptionType[]

    const remove = (index: number) => {
        update(fields?.filter((_, position) => position !== index))
    }

    const updateSheet = (id: number, sheet: SheetField) => {
        fields[id] = sheet
        update(fields)
    }

    return <FormSettingsColumns>
        <AreaSettings>
            <Button className='btn btn-primary' onClick={() => {
                update([...fields, {
                    format: '',
                    name: queryFields[0]
                }])
            }}><label>ADD COLUMN</label></Button>
        </AreaSettings>
        <ColumnsScroll>
            <Columns>
                {
                    fields.map((field, _index) => <SettingsColumn
                        id={_index}
                        field={field}
                        remove={() => remove(_index)} options={options}
                        update={(sheet) => updateSheet(_index, sheet)} />)
                }
            </Columns>
        </ColumnsScroll>
    </FormSettingsColumns>
}

const FormSettingsColumns = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;    
    position: relative;
    
`
const AreaSettings = styled.div`    
    height:50px;
    overflow: hidden;
    
`

const ColumnsScroll = styled.div`    
    overflow-x: auto;
    position: relative;
    height: 500px;
`
const Columns = styled.div`    
    position: absolute;
    height: auto;
    width: max-content;
    position: relative;    
    display: flex;
    flex-wrap: nowrap;  
    z-index: 0;
    
`

const Button = styled.button`
    width:100px;
    border-radius:3px;
    label{
        color: white;
        display: inline;
    }
`